const resources = {}
export default resources
